import CustomCardHeader from '../../components/card/CustomCardHeader'
import CardBody from '../../components/card/CardBody'
import CustomCard from '../../components/card/CustomCard'
import { LinksJsonUploader } from './LinksJsonUploader'

export default function GenerateLinks() {

  return (
    <div className="px-3 md:px-8 h-auto -mt-24">
      <div className="container mx-auto max-w-full">
        <div className="grid grid-cols-1 px-4 mb-16">
          <CustomCard>
            <CustomCardHeader color="blue" contentPosition="none">
              <div className="flex items-center justify-between w-full">
                <h2 className="text-2xl text-white">Generate Links</h2>
                <div className="flex space-x-2">

                </div>

              </div>
            </CustomCardHeader>
            <CardBody>
              <div className="overflow-x-auto">
                <LinksJsonUploader title="Upload a valid JSON file" />
              </div>
            </CardBody>
          </CustomCard>
        </div>
      </div>
    </div>
  )
}
